module.exports = __webpack_public_path__ + "static/media/shirt.c32bac08.png";